import { useDataChange } from 'Simple/Data.js'
import debounce from 'lodash/debounce.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.statements.old',
    viewPath: props.viewPath,
  })

  return debounce(function onChange(next) {
    if (!next) return
    change(next)
  }, 250)
}
